import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateModalEnum } from '../../enums/modal.enum';
import { HandleScreenService } from '../../services/handle-screen.service';

@Component({
  selector: 'ui-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',

})
export class ModalComponent implements OnChanges{
  @Input() templateModal: TemplateModalEnum = TemplateModalEnum.ERROR;
  @Input() isOpenModal: boolean = false;
  @Input() showCloseModalButton: boolean = false;
  @Input() withTimer: boolean = false;

  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  templateModalEnum = TemplateModalEnum;

  constructor(private handleScreenService: HandleScreenService) {}

  get isMobile(): boolean {
    return this.handleScreenService.isMobile()
  }

  ngOnChanges(changes: SimpleChanges): void{

    if((this.templateModal === TemplateModalEnum.SUCCESS || (this.templateModal === TemplateModalEnum.WARNING && this.withTimer)) && changes['isOpenModal'].currentValue){
      setTimeout(()=> {
        this.closeModal()
      }, 3000)
    }
  }

  closeModal(): void{
    this.closeModalEvent.emit(true)
  }
}
